import module from 'finanzas/module.js'
import template from './template.html'

function FinancesPosicionbancariaPrestamoFinanciamientoTablaComponent () {
  var $ctrl = this

  $ctrl.$onChanges = $onChanges
  $ctrl.recalcularInteres = recalcularInteres

  function $onChanges (changes) {
    if (changes.financiamiento || changes.importe) {
      redistribuir()
    }

    if (changes.interes) {
      recalcularInteres()
    }
  }

  function depurar () {
    var total = $ctrl.financiamiento.reduce(function (total, next, index, array) {
      if (index + 1 === array.length)
        return total
      else
        return {
          importe: parseFloat((total.importe + next.importe).toFixed(2)),
          interes: parseFloat((total.interes + next.interes).toFixed(2)),
          capital: parseFloat((total.capital + next.capital).toFixed(2)),
        }
    }, {
      importe: 0,
      interes: 0,
      capital: 0,
    })

    $ctrl.financiamiento[$ctrl.financiamiento.length - 1].importe = parseFloat(($ctrl.importe - total.importe).toFixed(2))
    $ctrl.financiamiento[$ctrl.financiamiento.length - 1].interes = parseFloat(($ctrl.interes - total.interes).toFixed(2))
    $ctrl.financiamiento[$ctrl.financiamiento.length - 1].capital = parseFloat(($ctrl.capital - total.capital).toFixed(2))

    totalizar()
  }

  function recalcularInteres (item) {
    var items = item ? [item] : $ctrl.financiamiento,
      porcentaje = $ctrl.interes / $ctrl.importe

    items.forEach(function (item) {
      item.interes = parseFloat((item.importe * porcentaje).toFixed(2))
      item.capital = parseFloat((item.importe + item.interes).toFixed(2))
    })

    depurar()
  }

  function redistribuir () {
    var importe = parseFloat(($ctrl.importe / $ctrl.financiamiento.length).toFixed(2)),
      interes = parseFloat(($ctrl.interes / $ctrl.financiamiento.length).toFixed(2)),
      capital = parseFloat(($ctrl.capital / $ctrl.financiamiento.length).toFixed(2))

    $ctrl.financiamiento.forEach(function (item) {
      item.importe = importe
      item.interes = interes
      item.capital = capital
    })

    depurar()
  }

  function totalizar () {
    $ctrl.diferencia = 0
    $ctrl.total = {
      importe: 0,
      interes: 0,
      capital: 0,
    }

    if (!Array.isArray($ctrl.financiamiento))
      return

    $ctrl.financiamiento.forEach(function (item) {
      $ctrl.total.importe = parseFloat(($ctrl.total.importe + item.importe).toFixed(2))
      $ctrl.total.interes = parseFloat(($ctrl.total.interes + item.interes).toFixed(2))
      $ctrl.total.capital = parseFloat(($ctrl.total.capital + item.capital).toFixed(2))
    })

    $ctrl.diferencia = Math.abs($ctrl.total.capital - $ctrl.capital) !== 0
  }
}

module.component('financesPosicionbancariaPrestamoFinanciamientoTabla', {
  controller: FinancesPosicionbancariaPrestamoFinanciamientoTablaComponent,
  template,
  bindings: {
    financiamiento: '<',
    importe: '<',
    interes: '<',
    capital: '<',
  },
})



// WEBPACK FOOTER //
// ./src/finanzas/components/posicionbancaria/prestamo/financiamiento/tabla/component.js